import React, { useState, useEffect, useContext } from "react";
// Components
import DisputesHeaderDark from "../Components/DisputesHeaderDark";
import DisputePageTitle from "../Components/DisputePageTitle";
import { Col, Row, Modal } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AuthContext } from "../AuthProvider";
import { Input, TextArea } from "../Components/Form/Form";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Buttons from "../Components/Button/Buttons";
import CustomModal from "../Components/CustomModal";
import GlobalContext from "../Context/Context";
import { Cloudinary } from "@cloudinary/url-gen";
import { AdvancedImage, responsive } from "@cloudinary/react";

import CloudinaryUploadWidget from "../Components/CloudinaryUploadWidget";

const getHelp = async (setHelp, setError) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}help/${encodeURIComponent(
        "Manage Adjudicators"
      )}/`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setHelp(response.data);
  } catch (error) {
    setError("Error fetching help!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const getAdjudicators = async (setAdjudicators, setError) => {
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicators/`
    );
    setAdjudicators(
      response.data.sort((a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      })
    );
  } catch (error) {
    setError("Error fetching adjudicators!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const getLegalFirms = async (setFirms, setError) => {
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}firms/`
    );
    setFirms(
      response.data.sort((a, b) => {
        const textA = a.firm.toUpperCase();
        const textB = b.firm.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      })
    );
  } catch (error) {
    setError("Error fetching firms!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

export default function ManageAdjudicators() {
  const [adjudicators, setAdjudicators] = useState(null);
  const [firms, setFirms] = useState(null);
  const [email, setEmail] = useState("");
  const [filter, setFilter] = useState("");
  const [help, setHelp] = useState(null);
  const [helping, setHelping] = useState(false);

  const { customModal, setCustomModal } = useContext(GlobalContext);

  const [selectedAdjudicator, setSelectedAdjudicator] = useState(null);
  const [gettingImage, setGettingImage] = useState(false)

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const { isLoggedIn, logout, isAdmin, loading } = useContext(AuthContext);
  const cloudName = window.__RUNTIME_CONFIG__.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const [publicId, setPublicId] = useState("");
  const [signatureData, setSignatureData] = useState({});

    const { timestamp, signature, cloud_name, upload_preset } = signatureData;

  // Upload Widget Configuration
  const uwConfig = {
    cloudName: cloud_name,
    uploadPreset: upload_preset,
    publicId: publicId,
    uploadSignatureTimestamp: timestamp,
    uploadSignature: signature,
    api_key: window.__RUNTIME_CONFIG__.REACT_APP_CLOUDINARY_API_KEY,
  };

  const [imageUrl, setImageUrl] = useState(null);
    const cld = new Cloudinary({
      cloud: {
        cloudName,
      },
    });



  useEffect(() => {
    getHelp(setHelp, setError);
    getAdjudicators(setAdjudicators, setError);
    getLegalFirms(setFirms, setError);
  }, []);

  useEffect(() => {
      if (publicId) {
        // Ensure publicId is set before making the request
        const getTimestampAndSignature = async () => {
          setGettingImage(true)
          try {
            const response = await axios.get(
              `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}cloudinary-sign-upload/`,
              {
                params: { public_id: publicId },
              }
            );
            setSignatureData(response.data); // Set the signature data
            setGettingImage(false)
          } catch (error) {
            setGettingImage(false)
            console.error("Error fetching Cloudinary signature:", error);
          }
        };

        getTimestampAndSignature();
      }
    }, [publicId]);

  const handleAdjSubmit = async (values) => {
    const cleanDataBeforeSubmit = (data) => {
      return {
        ...data,
        experience: data.experience?.replace(/[\r\n]+/g, "") || "",
        memaffil: data.memaffil?.replace(/[\r\n]+/g, "") || "",
      };
    };

    const accessToken = localStorage.getItem("accessToken");
    const updatedData = { ...selectedAdjudicator, ...values };
    const cleanedData = cleanDataBeforeSubmit(updatedData);

    try {
      const response = await axios.patch(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicator/update/`,
        cleanedData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const updatedAdjudicator = response.data;

      // Update selected adjudicator
      setSelectedAdjudicator(updatedAdjudicator);

      // Update the main list
      setAdjudicators((prev) =>
        prev.map((adj) =>
          adj.adjid === updatedAdjudicator.adjid ? updatedAdjudicator : adj
        )
      );

      setSuccess("Information updated!");
      setTimeout(() => setSuccess(null), 2000);
    } catch (err) {
      console.error(
        "Error updating adjudicator:",
        err.response?.data || err.message
      );
      setError("Failed to update information");
      setTimeout(() => setError(null), 2000);
    }
  };

  const handleNewAdjudicator = async (values) => {
    setSelectedAdjudicator(null);
    const accessToken = localStorage.getItem("accessToken");
    const now = new Date();
    const email = values.email;

    if (!email) {
      setError("Email is required to create an adjudicator.");
      setTimeout(() => {
        setError(null);
      }, 2000);
      return;
    }

    const data = {
      name: "New Adjudicator",
      qualifications: "",
      firm: "",
      memaffil: "",
      experience: "",
      type: 2,
      date: now,
      email: email,
      tel: "",
      active: 1,
      gender: "",
      ethnicity: "",
      firmid: 0,
    };
    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicators/create/`,
        data,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setAdjudicators((prev) => [response.data.adjudicator, ...prev]);
      setSelectedAdjudicator(response.data.adjudicator);

      setSuccess(null);
    } catch (error) {
      setError("Error while creating new adjudicator!");
      console.error(
        "Error creating new adjudicator:",
        error.response?.data || error.message
      );
      setTimeout(() => {
        setError(null);
      }, "2000");
    }
  };

  const handleDelete = async () => {
    const accessToken = localStorage.getItem("accessToken");
    setSuccess(null);

    try {
      if (
        window.confirm(
          `Are you sure you want to delete ${selectedAdjudicator.name} from adjudicators? This cannot be undone!`
        )
      ) {
        await axios.delete(
          `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}adjudicators/delete/${selectedAdjudicator.adjid}/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        setAdjudicators((prev) =>
          prev.filter((adj) => adj.adjid !== selectedAdjudicator.adjid)
        );

        setSelectedAdjudicator(null);
        setSuccess(`Deleted ${selectedAdjudicator.name}!`);

        setTimeout(() => {
          setSuccess(null);
        }, 2000);
      }
    } catch (error) {
      setError("Error deleting adjudicator");
      console.error(error.response?.data || error.message);

      setTimeout(() => {
        setError(null);
      }, 2000);
    }
  };


  return (
    <>
      <DisputesHeaderDark />
      {isAdmin && (
        <>
          <div className="relative">
            <DisputePageTitle title="Manage Adjudicators" />
            <button
              className="absolute bottom-[-50px] right-[16px] z-50"
              onClick={() => {
                setHelping(true);
              }}
            >
              <i className="fa-solid fa-circle-question text-[#ef8d23] text-[2rem]"></i>
            </button>
          </div>
          <Modal
            show={helping}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton onClick={() => setHelping(false)}>
              <Modal.Title className="text-[#ef8d23]">
                <i className="fa-solid fa-circle-question text-[#ef8d23] text-[2rem] pe-3"></i>
                {help?.model} Help
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ql-editor">
                <div dangerouslySetInnerHTML={{ __html: help?.content }}></div>
              </div>
            </Modal.Body>
          </Modal>
          <section className="pb-[160px] overflow-hidden cover-background ">
            <Row>
              <Col
                lg={3}
                className=" p-5 pt-4"
                data-test="adjudicators-manage-navbar"
              >
                {/* Modal Component Start */}
                <CustomModal.Wrapper
                  modalBtn={
                    <button
                      className="w-100 bg-[#ef8d23] text-white mb-3 py-2 hover:bg-[#ef8d23cc] block"
                      data-test="adjudicators-manage-new"
                      type="submit"
                    >
                      Add New Adjudicator
                    </button>
                  }
                  closeBtnOuter={true}
                >
                  <div className="w-[600px] sm:w-full justify-center">
                    <div className="p-[2.5rem] relative bg-white rounded sm:px-10">
                      <div className="mx-auto text-center modal-popup-main rounded-[6px] sm:px-[2.5rem] xs:px-0">
                        <Formik
                          initialValues={{
                            email: email,
                          }}
                          validationSchema={Yup.object().shape({
                            email: Yup.string()
                              .email("Invalid email.")
                              .required("Field is required.")
                              .max(100, "Must be less than 100 characters"),
                          })}
                          onSubmit={async (values, actions) => {
                            await handleNewAdjudicator(values);
                            actions.setSubmitting(false);
                            setCustomModal({
                              ...customModal,
                              isOpen: false,
                            });
                          }}
                        >
                          {({ isSubmitting, status, values }) => (
                            <Form>
                              <Input
                                data-test="adjudicators-manage-create-email"
                                showErrorMsg={true}
                                name="email"
                                type="email"
                                labelClass="mb-[10px]"
                                label={
                                  <div className="mb-[8px]">
                                    New Adjudicator Email
                                  </div>
                                }
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                                placeholder="Enter adjudicator email"
                              />

                              <Buttons
                                ariaLabel="Create"
                                type="submit"
                                className="btn-fill btn-fancy w-full font-medium font-serif rounded-none uppercase"
                                themeColor="#232323"
                                color="#fff"
                                size="md"
                                title="Create"
                              />
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </CustomModal.Wrapper>
                {/* Modal Component End */}
                <div className="bg-lightgray p-4 text-dark">
                  <input
                    className="w-100 p-3 mb-3 border"
                    data-test="adjudicators-manage-search"
                    placeholder="Search Name"
                    type="text"
                    value={filter}
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                  />
                  <div className="max-h-screen overflow-y-scroll">
                    {adjudicators &&
                      filter === "" &&
                      adjudicators.map((adj) => {
                        return (
                          <p
                            className={`${
                              adj.adjid === selectedAdjudicator?.adjid
                                ? "bg-[#ef8d23] text-white"
                                : ""
                            } p-1 hover:text-[#ef8d23]`}
                            key={adj.adjid}
                          >
                            <Link
                              onClick={() => {
                                setSelectedAdjudicator(adj);
                                setPublicId(`adj${adj.adjid}`);

                                setSuccess(null);
                              }}
                              data-test="adjudicators-manage-link"
                            >
                              {adj.name}
                            </Link>
                          </p>
                        );
                      })}
                    {adjudicators &&
                      filter !== "" &&
                      adjudicators
                        .filter((adj) => {
                          return adj.name
                            .toLowerCase()
                            .includes(filter.toLowerCase());
                        })
                        .map((adj) => {
                          return (
                            <p
                              className={`${
                                adj.adjid === selectedAdjudicator?.adjid
                                  ? "bg-[#ef8d23] text-white"
                                  : ""
                              } p-1 hover:text-[#ef8d23]`}
                              key={adj.adjid}
                            >
                              <Link
                                onClick={() => {
                                  setSelectedAdjudicator(adj);
                                  setPublicId(`adj${adj.adjid}`);

                                  setSuccess(null);
                                }}
                                data-test="adjudicators-manage-link"
                              >
                                {adj.name}
                              </Link>
                            </p>
                          );
                        })}
                  </div>
                </div>
              </Col>
              <Col lg={8} className="p-5">
                {success && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {success && (
                      <div
                        className="my-3 p-3 rounded text-[#ef8d23]"
                        style={{ border: "2px solid #ef8d23" }}
                      >
                        {success}
                      </div>
                    )}
                  </motion.div>
                )}
                {error && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {error && (
                      <div
                        className="my-3 p-3 rounded text-danger"
                        style={{ border: "2px solid red" }}
                      >
                        {error}
                      </div>
                    )}
                  </motion.div>
                )}

                {selectedAdjudicator && (
                  <>

                  {gettingImage ? <p className="w-[20%] h-[200px]"></p> :imageUrl ? (
                                                    <img
                                                      src={imageUrl}
                                                      style={{ maxWidth: "20%" }}
                                                      alt=""
                                                    />
                                                  ) : (
                                                    publicId && (
                                                      <div className="image-preview p-5">
                                                        <AdvancedImage
                                                          style={{ maxWidth: "20%" }}
                                                          cldImg={cld
                                                            .image(`adjudicators/${publicId}`)
                                                            .setVersion(selectedAdjudicator.imageVersion)}
                                                          plugins={[
                                                            responsive(),

                                                          ]}
                                                        />
                                                      </div>
                                                    )
                                                  )}
                                                  <div className="absolute top-[3%]">
                                                    <CloudinaryUploadWidget
                                                      uwConfig={uwConfig}
                                                      setPublicId={setPublicId}
                                                      setImageUrl={setImageUrl}
                                                      adjid={selectedAdjudicator.adjid}
                                                    />
                                                  </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        name: selectedAdjudicator.name,
                        firm: selectedAdjudicator.firm,
                        qualifications: selectedAdjudicator.qualifications,
                        memaffil: selectedAdjudicator.memaffil,
                        experience: selectedAdjudicator.experience,
                        email: selectedAdjudicator.email,
                        tel: selectedAdjudicator.tel,
                        type: selectedAdjudicator.type,
                        active: selectedAdjudicator.active,
                        gender: selectedAdjudicator.gender,
                        ethnicity: selectedAdjudicator.ethnicity,
                        firmid: selectedAdjudicator.firmid,
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string()
                          .email("Invalid email.")
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        memaffil: Yup.string().required("Field is required."),
                        experience: Yup.string().required("Field is required."),
                        name: Yup.string()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        qualifications: Yup.string()
                          .required("Field is required.")
                          .max(200, "Must be less than 200 characters"),
                        firm: Yup.string()
                          .required("Field is required.")
                          .max(200, "Must be less than 200 characters"),

                        tel: Yup.string()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        type: Yup.number()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        active: Yup.number()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        gender: Yup.string()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        ethnicity: Yup.string()
                          .required("Field is required.")
                          .max(100, "Must be less than 100 characters"),
                        firmid: Yup.number()
                          .required("Field is required."),
                      })}
                      onSubmit={async (values, actions) => {
                        await handleAdjSubmit(values);
                        actions.resetForm();
                      }}
                    >
                      {({ isSubmitting, status }) => (
                        <Form>
                          <div className="row">
                            <div className="col-lg-6">
                              <Input
                                data-test="adjudicators-update-input"
                                showErrorMsg={true}
                                name="name"
                                type="name"
                                labelClass="mb-[10px]"
                                label={
                                  <div className="mb-[8px]">
                                    Name
                                    <span className="text-[#fb4f58]">*</span>
                                  </div>
                                }
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                                placeholder="Enter your name"
                              />
                            </div>
                            <div className="col-lg-6">
                              <Input
                                data-test="adjudicators-update-input"
                                showErrorMsg={true}
                                name="firm"
                                type="firm"
                                labelClass="mb-[10px]"
                                label={
                                  <div className="mb-[8px]">
                                    Firm
                                    <span className="text-[#fb4f58]">*</span>
                                  </div>
                                }
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                                placeholder="Enter your firm"
                              />
                            </div>
                          </div>
                          <TextArea
                            data-test="adjudicators-update-input"
                            rows="2"
                            showErrorMsg={true}
                            name="qualifications"
                            type="qualifications"
                            labelClass="mb-[10px]"
                            label={
                              <div className="mb-[8px]">
                                Qualifications
                                <span className="text-[#fb4f58]">*</span>
                              </div>
                            }
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                            placeholder="Enter your qualifications"
                          />
                          <TextArea
                            data-test="adjudicators-update-input"
                            rows="2"
                            showErrorMsg={true}
                            name="memaffil"
                            type="memaffil"
                            labelClass="mb-[10px]"
                            label={
                              <div className="mb-[8px]">
                                Membership & Affiliations
                                <span className="text-[#fb4f58]">*</span>
                              </div>
                            }
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                            placeholder="Enter your membership affiliations"
                          />
                          <TextArea
                            data-test="adjudicators-update-input"
                            rows="2"
                            showErrorMsg={true}
                            name="experience"
                            type="experience"
                            labelClass="mb-[10px]"
                            label={
                              <div className="mb-[8px]">
                                Experience
                                <span className="text-[#fb4f58]">*</span>
                              </div>
                            }
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                            placeholder="Enter your experience"
                          />
                          <div className="row">
                            <div className="col-lg-6">
                              <Input
                                data-test="adjudicators-update-input"
                                showErrorMsg={true}
                                name="email"
                                type="email"
                                labelClass="mb-[10px]"
                                label={
                                  <div className="mb-[8px]">
                                    Email
                                    <span className="text-[#fb4f58]">*</span>
                                  </div>
                                }
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                                placeholder="Enter your email"
                              />
                            </div>
                            <div className="col-lg-6">
                              {" "}
                              <Input
                                data-test="adjudicators-update-input"
                                showErrorMsg={true}
                                name="tel"
                                type="tel"
                                labelClass="mb-[10px]"
                                label={
                                  <div className="mb-[8px]">
                                    Tel
                                    <span className="text-[#fb4f58]">*</span>
                                  </div>
                                }
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                                placeholder="Enter your telephone number"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              <label for="type">
                                <div className="mb-[8px]">
                                  Type
                                  <span className="text-[#fb4f58]">*</span>
                                </div>
                              </label>
                              <Field
                                as="select"
                                name="type"
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                              >
                                <option value="1">Senior Adjudicator</option>
                                <option value="2">Adjudicator</option>
                                <option value="3">Trainee Adjudicator</option>
                              </Field>
                            </div>
                            <div className="col-lg-6">
                              {" "}
                              <label for="active">
                                <div className="mb-[8px]">
                                  Active
                                  <span className="text-[#fb4f58]">*</span>
                                </div>
                              </label>
                              <Field
                                as="select"
                                name="active"
                                className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                              >
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                              </Field>
                            </div>
                          </div>{" "}
                          <label for="gender">
                            <div className="mb-[8px]">
                              Gender
                              <span className="text-[#fb4f58]">*</span>
                            </div>
                          </label>
                          <Field
                            as="select"
                            name="gender"
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                          >
                            <option value=""></option>
                            <option value="M">M</option>
                            <option value="F">F</option>
                          </Field>
                          <Input
                            data-test="adjudicators-update-input"
                            showErrorMsg={true}
                            name="ethnicity"
                            type="text"
                            labelClass="mb-[10px]"
                            label={
                              <div className="mb-[8px]">
                                Ethnicity
                                <span className="text-[#fb4f58]">*</span>
                              </div>
                            }
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                            placeholder="Enter the adjudicator's ethnicity"
                          />
                          <label for="type">
                            <div className="mb-[8px]">
                              Firm
                              <span className="text-[#fb4f58]">*</span>
                            </div>
                          </label>
                          <Field
                            as="select"
                            name="firmid"
                            className="py-[13px] px-[8px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                          >
                            {firms?.map((firm) => (
                              <option value={firm.firmid}>{firm.firm}</option>
                            ))}
                            {/* <option value="1">Senior Adjudicator</option>
                                <option value="2">Adjudicator</option>
                                <option value="3">Trainee Adjudicator</option> */}
                          </Field>
                          <div className="flex justify-content-between">
                            <div>
                              <button
                                className={
                                  "mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                                }
                                type="submit"
                                data-test="adjudicators-manage-update"
                              >
                                Update
                              </button>
                            </div>

                            <button
                              className={
                                "mt-3 text-white bg-[#dc3545] py-1 px-3 ml-2] hover:bg-[#dc3545cc]"
                              }
                              onClick={handleDelete}
                              data-test="adjudicators-manage-delete"
                              type="button"
                            >
                              Delete
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}
              </Col>
            </Row>
          </section>
        </>
      )}
      {!isLoggedIn && <DisputePageTitle title="Unauthorized" />}
      {isLoggedIn && !isAdmin && <DisputePageTitle title="Unauthorized" />}
    </>
  );
}
